/**
 * @generated SignedSource<<4e7b300cc6654e06147ff97feea114d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfigurableMenuItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Plans" | "Nav4Projects" | "Nav4Roadmaps_query">;
  readonly " $fragmentType": "ConfigurableMenuItem";
};
export type ConfigurableMenuItem$key = {
  readonly " $data"?: ConfigurableMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfigurableMenuItem",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Nav4Projects"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Filters"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Plans"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Apps"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Operations"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Roadmaps_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "6819bd0a98d8be3f1e4a0a09380ce499";

export default node;
